// extracted by mini-css-extract-plugin
export var buttonContainer = "_9g-1";
export var fontSizeSelect = "_9g-3";
export var formatSelect = "_9g-2";
export var formats = "_9g-4";
export var hidden = "_9g-5";
export var icon = "_9g-6";
export var select = "_9g-0";